module.exports = __webpack_public_path__ + "img/image_24.d1cbeed9.png";